import { supabase } from '@/integrations/supabase/client';
import { slugsWithSupply } from '@/utils/professionSupply';

// Slugs of the trades that have at least one verified, active professional; null if unknown.
export const fetchProfessionSupply = async (): Promise<Set<string> | null> => {
  try {
    const [professions, pros] = await Promise.all([
      supabase.from('professions').select('id, profession_id').eq('is_active', true),
      supabase.from('professionals_public_view').select('profession_ids').eq('is_verified', true),
    ]);
    if (professions.error || pros.error || !professions.data?.length) return null;
    return slugsWithSupply(professions.data, (pros.data ?? []) as Array<{ profession_ids: string[] | null }>);
  } catch {
    return null;
  }
};
